import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useTimer } from "../hooks/useTimer";
import { useWindowSize } from "../hooks/useWindowsSize";

let timerProps = {
  isPlaying: true,
  size: 120,
  strokeWidth: 5,
};

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;

const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;
const getTimeDays = (time) => (time / daySeconds) | 0;
const defaultText = "шууд тохирол явагдах өдөр";

const renderTime = (dimension, time) => {
  return (
    <div>
      <div className="time sm:text-[25px] xs:text-[25px] md:text-[30px] lg:text-[40px]">
        {time}
      </div>
    </div>
  );
};

const CountdownTimer = ({ targetDate, time, size, text = null, textColor = "text-[#0987F3]"}) => {
  // const { t } = useTranslation("common");
  const [days, hours, minutes, seconds] = useTimer(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return (
      <>
        <div className={`${textColor} text-xl  tablet:text-[20px] font-semibold w-full text-center mobile:text-base laptop:text-base`}>
          <p className="uppercase">Тохирол явагдаж дууссан байна.</p>
        </div>
        <div className="mt-10 w-full">

          <ShowCounter targetDate={targetDate} counterSize={size} />
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className={`${textColor} text-xl  tablet:text-[20px] font-semibold w-full text-center mobile:text-base laptop:text-base`}>
          <p className="uppercase">{text != null ? text : defaultText}</p>
          <p>{time}</p>
        </div>
        <div className="mt-10 w-full">
          <ShowCounter targetDate={targetDate} counterSize={size} textColor={textColor} />
        </div>
      </>
    );
  }
};

const ShowCounter = ({ targetDate, counterSize, textColor }) => {
  // const { t } = useTranslation("common");
  const size = useWindowSize();
  let customSize = 70;
  if(counterSize === "small"){
    customSize = 75;
  }else{
    if (size.width > 1268) {
      customSize = 120;
    } else if (size.width > 768) {
      customSize = 90;
    } else if (size.width > 575) {
      customSize = 100;
    }
  }

  const stratTime = Date.now() / 1000;
  const endTime = new Date(targetDate).getTime() / 1000;
  const remainingTime = endTime - stratTime;
  const days = Math.ceil(remainingTime / daySeconds);
  const daysDuration = days * daySeconds;
  let textStyle = `pt-5 ${textColor} text-xl uppercase mobile:text-base tablet:text-base laptop:text-base`;
  let numStyle = `${textColor} font-semibold text-4xl mobile:text-xl tablet:text-2xl laptop:text-2xl`;
  if(counterSize === "small"){
    textStyle = `pt-4 ${textColor} text-md uppercase mobile:text-base tablet:text-base`;
    numStyle = `${textColor} font-semibold text-2xl mobile:text-xl`;
    timerProps.strokeWidth = 4;
  }


  return (
    <div className="flex flex-col justify-center">
      <svg className="invisible m-0 p-0 h-0 w-0">
        <defs>
          <linearGradient id="your-unique-id">
            <stop offset="5%" stopColor="#FF8801" />
            <stop offset="95%" stopColor="#FFCD01" />
          </linearGradient>
        </defs>
      </svg>
      <div className="flex flex-row items-center justify-between md:justify-between md:pr-20 sm:space-x-6">
        <div className="flex flex-col items-center">
          <CountdownCircleTimer
            {...timerProps}
            size={customSize}
            colors="url(#your-unique-id)"
            duration={daysDuration}
            trailStrokeWidth={1}
            trailColor="#0987F3"
            initialRemainingTime={remainingTime}
          >
            {({ elapsedTime, color }) => (
              <span
                style={{ color }}
                className={numStyle}
              >
                {renderTime("days", getTimeDays(daysDuration - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>
          <p className={textStyle}>Өдөр</p>
        </div>
        <div className="flex flex-col items-center">
          <CountdownCircleTimer
            {...timerProps}
            colors="url(#your-unique-id)"
            size={customSize}
            duration={daySeconds}
            trailStrokeWidth={1}
            trailColor="#0987F3"
            initialRemainingTime={remainingTime % daySeconds}
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > hourSeconds,
            })}
          >
            {({ elapsedTime, color }) => (
              <span
                style={{ color }}
                className={numStyle}
              >
                {renderTime("hours", getTimeHours(daySeconds - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>
          <p className={textStyle}>Цаг</p>
        </div>
        <div className="flex flex-col items-center">
          <CountdownCircleTimer
            {...timerProps}
            colors="url(#your-unique-id)"
            size={customSize}
            duration={hourSeconds}
            initialRemainingTime={remainingTime % hourSeconds}
            trailStrokeWidth={1}
            trailColor="#0987F3"
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds,
            })}
          >
            {({ elapsedTime, color }) => (
              <span
                style={{ color }}
                className={numStyle}
              >
                {renderTime("minutes", getTimeMinutes(hourSeconds - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>
          <p className={textStyle}>Минут</p>
        </div>
        <div className="flex flex-col items-center">
          <CountdownCircleTimer {...timerProps}
            size={customSize}
            duration={minuteSeconds}
            initialRemainingTime={remainingTime % minuteSeconds}
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > 0,
            })}
            trailColor="#0987F3"
            trailStrokeWidth={1} colors="url(#your-unique-id)">
            {({ elapsedTime, color }) => {
              return (
                <span
                  style={{ color }}
                  className={numStyle}
                >
                  {renderTime("seconds", getTimeSeconds(elapsedTime))}
                </span>
              );
            }}
          </CountdownCircleTimer>
          <p className={textStyle}>Секунд</p>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
